import React from 'react';

import type { AgentExecutionStepDto } from '../../types/agentPlatform';

import { labelExecutionStatus } from '../../utils/agentPlatformLabels';
import { normalizeAgentExecutionStatus } from '../../utils/agentPlatformEnumNormalize';



type Props = {

  steps: AgentExecutionStepDto[];

};



function stepTypeLabel(stepType: string): string {

  const map: Record<string, string> = {

    LlmCall: 'Chamada LLM',

    ToolCall: 'Ferramenta',

    FlowCall: 'Fluxo',

    GraphNode: 'Nó do grafo',

    Respond: 'Resposta',

    Router: 'Roteador',

  };

  return map[stepType] ?? stepType;

}



export const AgentExecutionTimeline: React.FC<Props> = ({ steps }) => {

  const sorted = [...steps].sort((a, b) => a.stepOrder - b.stepOrder);



  if (sorted.length === 0) {

    return <p className="text-sm text-slate-500">Nenhum step registrado.</p>;

  }



  return (

    <ol className="relative border-l-2 border-red-200 ml-3 space-y-6">

      {sorted.map(step => {
        const statusKey = normalizeAgentExecutionStatus(step.status);

        return (
        <li key={step.id} className="ml-6">
          <span
            className={`absolute -left-[7px] flex h-3.5 w-3.5 rounded-full ring-4 ring-white shadow-sm ${
              statusKey === 'Completed'
                ? 'bg-emerald-500'
                : statusKey === 'Failed'
                  ? 'bg-red-500'
                  : statusKey === 'Running'
                    ? 'bg-amber-400 animate-pulse'
                    : 'bg-slate-400'
            }`}
          />

          <div className="rounded-xl border border-slate-200/80 bg-white/90 backdrop-blur-sm p-4 shadow-md shadow-slate-200/40">

            <div className="flex flex-wrap items-center gap-2 mb-2">

              <span className="text-xs font-mono text-slate-400">#{step.stepOrder}</span>

              <span className="text-sm font-semibold text-slate-900">{stepTypeLabel(step.stepType)}</span>

              {step.nodeId && (

                <span className="text-xs font-mono bg-stone-100 text-stone-700 px-1.5 py-0.5 rounded">

                  {step.nodeId}

                </span>

              )}

              <span className="text-xs text-slate-500 ml-auto">

                {labelExecutionStatus(step.status)}

                {step.durationMs != null && ` · ${step.durationMs}ms`}

              </span>

            </div>

            {step.errorMessage && (

              <p className="text-sm text-red-700 mb-2">{step.errorMessage}</p>

            )}

            {step.input && (

              <details className="text-xs mb-1">

                <summary className="cursor-pointer text-red-600 font-medium">Input</summary>

                <pre className="mt-1 p-2 bg-slate-50 rounded-lg overflow-auto max-h-40 font-mono text-slate-700 border border-slate-100">

                  {step.input}

                </pre>

              </details>

            )}

            {step.output && (

              <details className="text-xs">

                <summary className="cursor-pointer text-red-600 font-medium">Output</summary>

                <pre className="mt-1 p-2 bg-slate-50 rounded-lg overflow-auto max-h-40 font-mono text-slate-700 border border-slate-100">

                  {step.output}

                </pre>

              </details>

            )}

            {step.tokenUsage && (

              <p className="text-xs text-slate-500 mt-2">Tokens: {step.tokenUsage}</p>

            )}

          </div>
        </li>
        );
      })}

    </ol>

  );

};


